webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/table/_table.js
var _table = __webpack_require__("fnDg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/table/table.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var table = (_table["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/table/table.vue
function injectStyle (ssrContext) {
  __webpack_require__("4veK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  table,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var table_table = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3doe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4veK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7gQW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-awesome/components/Icon.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ var Icon = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return defineProperty_default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e22f0aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome/components/Icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",function(){return [(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-awesome/components/Icon.vue
function injectStyle (ssrContext) {
  __webpack_require__("jSVj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Icon,
  components_Icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_awesome_components_Icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-input/_form-input.js
var _form_input = __webpack_require__("qRo1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_input = (_form_input["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
function injectStyle (ssrContext) {
  __webpack_require__("n9mN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_input_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/modal/_modal.js
var _modal = __webpack_require__("rKsW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var modal = (_modal["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("xBwK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-file/_form-file.js
var _form_file = __webpack_require__("9NuQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_file = (_form_file["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y9O/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_file,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_file_form_file = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__("Jmt5");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/edit.js
var edit = __webpack_require__("Vej+");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/remove.js
var remove = __webpack_require__("gfF8");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/plus.js
var plus = __webpack_require__("rcsw");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/arrow-up.js
var arrow_up = __webpack_require__("FE82");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/arrow-down.js
var arrow_down = __webpack_require__("BIRJ");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 118 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/vue-notification/dist/index.js
var dist = __webpack_require__("CLX7");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-awesome/components/Icon.vue + 2 modules
var Icon = __webpack_require__("D4uH");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: "app",
  methods: {
    logout: function logout() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$auth.signOut();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae972d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto",attrs:{"id":"app"}},[_c('notifications'),_vm._v(" "),(_vm.authState.isAuthenticated)?[_c('div',{staticClass:"clearfix"},[_c('b-button',{staticClass:"float-right",attrs:{"pill":"","variant":"outline-danger"},on:{"click":_vm.logout}},[_vm._v("\n        Logout\n      ")])],1)]:_vm._e(),_vm._v(" "),_c('router-view')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("PUbj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/notify.js
var Notify = {
  methods: {
    notifyInfo: function notifyInfo(text) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Info";

      this.$notify({
        title: title,
        text: text,
        type: "success"
      });
    },
    notifyWarn: function notifyWarn(text) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Warning";

      this.$notify({
        title: title,
        text: text,
        type: "warn"
      });
    },
    notifyError: function notifyError(text) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Error";

      this.$notify({
        title: title,
        text: text,
        type: "error"
      });
    },
    notifySuccess: function notifySuccess(text) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Success";

      this.$notify({
        title: title,
        text: text,
        type: "success"
      });
    }
  }
};

/* harmony default export */ var notify = (Notify);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/vue.config.js
var vue_config = __webpack_require__("vK/+");
var vue_config_default = /*#__PURE__*/__webpack_require__.n(vue_config);

// CONCATENATED MODULE: ./src/api.js





var api_Api = function () {
  function Api(accessToken) {
    classCallCheck_default()(this, Api);

    this.client = Api.makeClient(vue_config_default.a.printers.host, accessToken);
  }

  createClass_default()(Api, null, [{
    key: "makeClient",
    value: function makeClient(printerHost, accessToken) {
      var options = {
        baseURL: printerHost,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer: " + accessToken
        }
      };
      return axios_default.a.create(options);
    }
  }]);

  return Api;
}();

/* harmony default export */ var api = (api_Api);
// CONCATENATED MODULE: ./src/printers_api.js









var printers_api_PrintersApi = function (_Api) {
  inherits_default()(PrintersApi, _Api);

  function PrintersApi() {
    classCallCheck_default()(this, PrintersApi);

    return possibleConstructorReturn_default()(this, (PrintersApi.__proto__ || get_prototype_of_default()(PrintersApi)).apply(this, arguments));
  }

  createClass_default()(PrintersApi, [{
    key: "addPrinterToGroup",
    value: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(printerId, groupId) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.client.put("/print_groups/" + groupId + "/add_printer", {
                  printer_id: printerId
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addPrinterToGroup(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return addPrinterToGroup;
    }()
  }, {
    key: "removePrinterFromGroup",
    value: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(printerId, groupId) {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.client.put("/print_groups/" + groupId + "/remove_printer", {
                  printer_id: printerId
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removePrinterFromGroup(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return removePrinterFromGroup;
    }()
  }, {
    key: "retrieveServers",
    value: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.client.get("/print_servers"));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function retrieveServers() {
        return _ref3.apply(this, arguments);
      }

      return retrieveServers;
    }()
  }, {
    key: "retrievePrintGroupPrinters",
    value: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(printGroupId) {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.client.get("/print_groups/" + printGroupId + "/printers.json"));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function retrievePrintGroupPrinters(_x5) {
        return _ref4.apply(this, arguments);
      }

      return retrievePrintGroupPrinters;
    }()
  }, {
    key: "retrievePrintGroups",
    value: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(catalogueId) {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.client.get("/catalogues/" + catalogueId + "/print_groups"));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function retrievePrintGroups(_x6) {
        return _ref5.apply(this, arguments);
      }

      return retrievePrintGroups;
    }()
  }, {
    key: "retrievePrintGroup",
    value: function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(id) {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.client.get("/print_groups/" + id));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function retrievePrintGroup(_x7) {
        return _ref6.apply(this, arguments);
      }

      return retrievePrintGroup;
    }()
  }, {
    key: "createPrintGroup",
    value: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(catalogueId, printGroup) {
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.client.post("/catalogues/" + catalogueId + "/print_groups", {
                  description: printGroup.description
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function createPrintGroup(_x8, _x9) {
        return _ref7.apply(this, arguments);
      }

      return createPrintGroup;
    }()
  }, {
    key: "updatePrintGroup",
    value: function () {
      var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(id, printGroup) {
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.client.put("/print_groups/" + id, printGroup));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function updatePrintGroup(_x10, _x11) {
        return _ref8.apply(this, arguments);
      }

      return updatePrintGroup;
    }()
  }, {
    key: "deletePrintGroup",
    value: function () {
      var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(id) {
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.client.delete("/print_groups/" + id));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deletePrintGroup(_x12) {
        return _ref9.apply(this, arguments);
      }

      return deletePrintGroup;
    }()
  }, {
    key: "createCatalogue",
    value: function () {
      var _ref10 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(catalogue) {
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this.client.post("/catalogues", catalogue));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function createCatalogue(_x13) {
        return _ref10.apply(this, arguments);
      }

      return createCatalogue;
    }()
  }, {
    key: "updateCatalogue",
    value: function () {
      var _ref11 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11(id, catalogue) {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this.client.put("/catalogues/" + id, catalogue));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function updateCatalogue(_x14, _x15) {
        return _ref11.apply(this, arguments);
      }

      return updateCatalogue;
    }()
  }, {
    key: "listCatalogues",
    value: function () {
      var _ref12 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this.client.get("/catalogues"));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function listCatalogues() {
        return _ref12.apply(this, arguments);
      }

      return listCatalogues;
    }()
  }, {
    key: "retrieveCatalogue",
    value: function () {
      var _ref13 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13(id) {
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.client.get("/catalogues/" + id));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function retrieveCatalogue(_x16) {
        return _ref13.apply(this, arguments);
      }

      return retrieveCatalogue;
    }()
  }, {
    key: "deleteCatalogue",
    value: function () {
      var _ref14 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14(catalogueId) {
        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.client.delete("/catalogues/" + catalogueId));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function deleteCatalogue(_x17) {
        return _ref14.apply(this, arguments);
      }

      return deleteCatalogue;
    }()
  }, {
    key: "deleteServer",
    value: function () {
      var _ref15 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15(serverId) {
        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this.client.delete("/print_servers/" + serverId));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function deleteServer(_x18) {
        return _ref15.apply(this, arguments);
      }

      return deleteServer;
    }()
  }, {
    key: "updateServer",
    value: function () {
      var _ref16 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16(id, server) {
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this.client.put("/print_servers/" + id, server));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateServer(_x19, _x20) {
        return _ref16.apply(this, arguments);
      }

      return updateServer;
    }()
  }, {
    key: "createServer",
    value: function () {
      var _ref17 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17(server) {
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this.client.post("/print_servers", server));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function createServer(_x21) {
        return _ref17.apply(this, arguments);
      }

      return createServer;
    }()
  }, {
    key: "addPrinter",
    value: function () {
      var _ref18 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18(serverId, printer) {
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.client.post("/print_servers/" + serverId + "/printers", printer));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function addPrinter(_x22, _x23) {
        return _ref18.apply(this, arguments);
      }

      return addPrinter;
    }()
  }, {
    key: "retrievePrinter",
    value: function () {
      var _ref19 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19(id) {
        return regenerator_default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this.client.get("/printers/" + id));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function retrievePrinter(_x24) {
        return _ref19.apply(this, arguments);
      }

      return retrievePrinter;
    }()
  }, {
    key: "updatePrinter",
    value: function () {
      var _ref20 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20(id, printer) {
        return regenerator_default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this.client.put("/printers/" + id, printer));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function updatePrinter(_x25, _x26) {
        return _ref20.apply(this, arguments);
      }

      return updatePrinter;
    }()
  }, {
    key: "retrievePrinterDimensions",
    value: function () {
      var _ref21 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21(id) {
        return regenerator_default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this.client.get("/printers/" + id + "/dimensions"));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function retrievePrinterDimensions(_x27) {
        return _ref21.apply(this, arguments);
      }

      return retrievePrinterDimensions;
    }()
  }, {
    key: "deleteDimension",
    value: function () {
      var _ref22 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22(id) {
        return regenerator_default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this.client.delete("/dimensions/" + id));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function deleteDimension(_x28) {
        return _ref22.apply(this, arguments);
      }

      return deleteDimension;
    }()
  }, {
    key: "createDimension",
    value: function () {
      var _ref23 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23(printerId, dimension) {
        return regenerator_default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this.client.post("printers/" + printerId + "/dimensions", dimension));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function createDimension(_x29, _x30) {
        return _ref23.apply(this, arguments);
      }

      return createDimension;
    }()
  }, {
    key: "retrieveServer",
    value: function () {
      var _ref24 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24(id) {
        return regenerator_default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this.client.get("/print_servers/" + id));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function retrieveServer(_x31) {
        return _ref24.apply(this, arguments);
      }

      return retrieveServer;
    }()
  }, {
    key: "retrievePrinters",
    value: function () {
      var _ref25 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee25(serverId) {
        return regenerator_default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.client.get("/print_servers/" + serverId + "/printers"));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function retrievePrinters(_x32) {
        return _ref25.apply(this, arguments);
      }

      return retrievePrinters;
    }()
  }]);

  return PrintersApi;
}(api);

/* harmony default export */ var printers_api = (printers_api_PrintersApi);
// EXTERNAL MODULE: ./node_modules/click-confirm/dist/click-confirm.common.js
var click_confirm_common = __webpack_require__("ubFL");
var click_confirm_common_default = /*#__PURE__*/__webpack_require__.n(click_confirm_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/ServerTable.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ServerTable = ({
  components: {
    "click-confirm": click_confirm_common_default.a
  },
  mixins: [notify],
  data: function data() {
    return {
      fields: ["host", "api_key", "server_type", "actions"],
      servers: []
    };
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.refresh();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    refresh: function refresh() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return new printers_api(_this2.$auth.getAccessToken()).retrieveServers();

              case 3:
                response = _context2.sent;

                _this2.servers = response.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                _this2.notifyError(_context2.t0.message);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    removeServer: function removeServer(item) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return new printers_api(_this3.$auth.getAccessToken()).deleteServer(item.id);

              case 3:
                _context3.next = 5;
                return _this3.refresh();

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                _this3.notifyError(_context3.t0.message);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a4b014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/ServerTable.vue
var ServerTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('b-button',{attrs:{"to":{ name: 'CreatePrintServer' }}},[_vm._v("Create")])],1),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.servers},scopedSlots:_vm._u([{key:"actions",fn:function(cell){return [_c('b-button-group',[_c('b-button',{staticClass:"align-top",attrs:{"size":"sm","variant":"outline-secondary","to":{ name: 'EditPrintServer', params: { id: cell.item.id } }}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"edit"}})],1),_vm._v(" "),_c('click-confirm',[_c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.removeServer(cell.item)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"remove"}})],1)],1)],1)]}}])})],1)}
var ServerTable_staticRenderFns = []
var ServerTable_esExports = { render: ServerTable_render, staticRenderFns: ServerTable_staticRenderFns }
/* harmony default export */ var printers_ServerTable = (ServerTable_esExports);
// CONCATENATED MODULE: ./src/components/printers/ServerTable.vue
var ServerTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ServerTable___vue_template_functional__ = false
/* styles */
var ServerTable___vue_styles__ = null
/* scopeId */
var ServerTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServerTable___vue_module_identifier__ = null
var ServerTable_Component = ServerTable_normalizeComponent(
  ServerTable,
  printers_ServerTable,
  ServerTable___vue_template_functional__,
  ServerTable___vue_styles__,
  ServerTable___vue_scopeId__,
  ServerTable___vue_module_identifier__
)

/* harmony default export */ var components_printers_ServerTable = (ServerTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/CatalogueTable.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CatalogueTable = ({
  components: {
    "click-confirm": click_confirm_common_default.a
  },
  mixins: [notify],
  data: function data() {
    return {
      fields: ["description", "actions"],
      catalogues: [],
      catalogue: {
        description: ""
      }
    };
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.refresh();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    refresh: function refresh() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return new printers_api(_this2.$auth.getAccessToken()).listCatalogues();

              case 3:
                response = _context2.sent;

                _this2.catalogues = response.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                _this2.notifyError(_context2.t0.message);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    createCatalogue: function createCatalogue() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return new printers_api(_this3.$auth.getAccessToken()).createCatalogue(_this3.catalogue);

              case 3:
                _this3.refresh();
                _this3.catalogue = { description: "" };
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                _this3.notifyError(_context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    deleteCatalogue: function deleteCatalogue(item) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return new printers_api(_this4.$auth.getAccessToken()).deleteCatalogue(item.id);

              case 3:
                _this4.refresh();
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);

                _this4.notifyError(_context4.t0.message);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 6]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d3b6b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/CatalogueTable.vue
var CatalogueTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.createCatalogue",modifiers:{"createCatalogue":true}}]},[_vm._v("Create Catalogue")])],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"createCatalogue","title":"Create Catalogue"},on:{"ok":_vm.createCatalogue}},[_c('b-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.catalogue.description),callback:function ($$v) {_vm.$set(_vm.catalogue, "description", $$v)},expression:"catalogue.description"}})],1),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.catalogues},scopedSlots:_vm._u([{key:"actions",fn:function(cell){return [_c('b-button-group',[_c('b-button',{staticClass:"align-top",attrs:{"size":"sm","variant":"outline-secondary","to":{ name: 'EditCatalogue', params: { id: cell.item.id } }}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"edit"}})],1),_vm._v(" "),_c('click-confirm',[_c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCatalogue(cell.item)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"remove"}})],1)],1)],1)]}}])})],1)}
var CatalogueTable_staticRenderFns = []
var CatalogueTable_esExports = { render: CatalogueTable_render, staticRenderFns: CatalogueTable_staticRenderFns }
/* harmony default export */ var printers_CatalogueTable = (CatalogueTable_esExports);
// CONCATENATED MODULE: ./src/components/printers/CatalogueTable.vue
var CatalogueTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CatalogueTable___vue_template_functional__ = false
/* styles */
var CatalogueTable___vue_styles__ = null
/* scopeId */
var CatalogueTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CatalogueTable___vue_module_identifier__ = null
var CatalogueTable_Component = CatalogueTable_normalizeComponent(
  CatalogueTable,
  printers_CatalogueTable,
  CatalogueTable___vue_template_functional__,
  CatalogueTable___vue_styles__,
  CatalogueTable___vue_scopeId__,
  CatalogueTable___vue_module_identifier__
)

/* harmony default export */ var components_printers_CatalogueTable = (CatalogueTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Main = ({
  components: {
    "printers-server-table": components_printers_ServerTable,
    "printers-catalogue-table": components_printers_CatalogueTable
  },
  data: function data() {
    return {
      items: [{
        text: "Home",
        active: true
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-add213bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_vm._v(" "),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Catalogues","active":""}},[_c('printers-catalogue-table')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Servers & Printers"}},[_c('printers-server-table')],1)],1)],1)}
var Main_staticRenderFns = []
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var components_Main = (Main_esExports);
// CONCATENATED MODULE: ./src/components/Main.vue
function Main_injectStyle (ssrContext) {
  __webpack_require__("xhSA")
}
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = Main_injectStyle
/* scopeId */
var Main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main,
  components_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var src_components_Main = (Main_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/PrintersList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PrintersList = ({
  mixins: [notify],
  props: ["printers"],
  data: function data() {
    return {
      fields: ["description", "ticket_type", "actions"]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3611a756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/PrintersList.vue
var PrintersList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.printers},scopedSlots:_vm._u([{key:"actions",fn:function(cell){return [_c('b-button-group',{attrs:{"vertical":""}},[_c('b-button',{staticClass:"align-top",attrs:{"size":"sm","variant":"outline-secondary","to":{ name: 'EditPrinter', params: { id: cell.item.id } }}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"edit"}})],1)],1)]}}])})],1)}
var PrintersList_staticRenderFns = []
var PrintersList_esExports = { render: PrintersList_render, staticRenderFns: PrintersList_staticRenderFns }
/* harmony default export */ var printers_PrintersList = (PrintersList_esExports);
// CONCATENATED MODULE: ./src/components/printers/PrintersList.vue
function PrintersList_injectStyle (ssrContext) {
  __webpack_require__("7gQW")
}
var PrintersList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrintersList___vue_template_functional__ = false
/* styles */
var PrintersList___vue_styles__ = PrintersList_injectStyle
/* scopeId */
var PrintersList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintersList___vue_module_identifier__ = null
var PrintersList_Component = PrintersList_normalizeComponent(
  PrintersList,
  printers_PrintersList,
  PrintersList___vue_template_functional__,
  PrintersList___vue_styles__,
  PrintersList___vue_scopeId__,
  PrintersList___vue_module_identifier__
)

/* harmony default export */ var components_printers_PrintersList = (PrintersList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/PrintServerCreate.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var PrintServerCreate = ({
  mixins: [notify],
  components: {
    "printers-list": components_printers_PrintersList
  },
  data: function data() {
    return {
      crumbs: [{
        text: "Home",
        href: "/"
      }, {
        text: "Server",
        active: true
      }],
      server: {
        id: 0,
        api_key: "",
        host: "",
        server_type: "quickets"
      },
      printers: [],
      newPrinterDescription: "",
      addingPrinter: false
    };
  },

  computed: {
    creating: function creating() {
      return this.server.id === 0;
    }
  },
  watch: {
    $route: function $route(to) {
      this.loadItem(to.params.id);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.loadItem(to.params.id);
    });
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.creating) {
                  _this.create();
                } else {
                  _this.update();
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    update: function update() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return new printers_api(_this2.$auth.getAccessToken()).updateServer(_this2.server.id, _this2.server);

              case 3:
                response = _context2.sent;

                _this2.server = response.data;
                _context2.next = 7;
                return _this2.syncPrinters();

              case 7:
                _this2.notifySuccess("Successfully Updated Print Server");
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);

                _this2.notifyError(_context2.t0.message);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    },
    create: function create() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return new printers_api(_this3.$auth.getAccessToken()).createServer(_this3.server);

              case 3:
                response = _context3.sent;

                _this3.server = response.data;
                _context3.next = 7;
                return _this3.syncPrinters();

              case 7:
                _this3.notifySuccess("Successfully Created Print Server");
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                _this3.notifyError(_context3.t0.message);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    syncPrinters: function syncPrinters() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var remotePrinters, localPrinters, printerNames, printersToCreate;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                remotePrinters = void 0;
                _context4.prev = 1;
                _context4.next = 4;
                return _this4.loadQuicketPrinters();

              case 4:
                remotePrinters = _context4.sent;
                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);

                _this4.notifyWarn("Could not reach " + _this4.server.host + " to load its printers. Syncing only works from a computer on the print server's network. Add printers manually instead.", "Printers Not Synced");
                return _context4.abrupt("return");

              case 11:
                _context4.prev = 11;
                _context4.next = 14;
                return _this4.loadPrinters();

              case 14:
                localPrinters = _context4.sent;
                printerNames = localPrinters.map(function (printer) {
                  return printer.description;
                });
                printersToCreate = remotePrinters.filter(function (x) {
                  return printerNames.indexOf(x) === -1;
                });
                _context4.next = 19;
                return promise_default.a.all(printersToCreate.map(function (printer) {
                  return _this4.addPrinter(printer);
                }));

              case 19:
                _context4.next = 21;
                return _this4.refreshPrinters();

              case 21:
                _context4.next = 26;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t1 = _context4["catch"](11);

                _this4.notifyError(_context4.t1.message);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 7], [11, 23]]);
      }))();
    },
    addManualPrinter: function addManualPrinter() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var errors;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.addingPrinter = true;
                _context5.prev = 1;
                _context5.next = 4;
                return _this5.addPrinter(_this5.newPrinterDescription.trim());

              case 4:
                _this5.newPrinterDescription = "";
                _context5.next = 7;
                return _this5.refreshPrinters();

              case 7:
                _this5.notifySuccess("Successfully Added Printer");
                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](1);
                errors = _context5.t0.response && _context5.t0.response.data;

                if (errors && errors.description) {
                  _this5.notifyError("Printer name " + errors.description.join(", "));
                } else {
                  _this5.notifyError(_context5.t0.message);
                }

              case 14:
                _context5.prev = 14;

                _this5.addingPrinter = false;
                return _context5.finish(14);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[1, 10, 14, 17]]);
      }))();
    },
    addPrinter: function addPrinter(printer) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return new printers_api(_this6.$auth.getAccessToken()).addPrinter(_this6.server.id, {
                  description: printer
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    load: function load(location) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var response;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return axios_default.a.get(location);

              case 3:
                response = _context7.sent;

                _this7.server = response.data;
                _context7.next = 7;
                return _this7.refreshPrinters();

              case 7:
                _context7.next = 12;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);

                _this7.notifyError(_context7.t0.message);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 9]]);
      }))();
    },
    loadItem: function loadItem(id) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var response;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (is_integer_default()(parseInt(id, 0))) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                _context8.prev = 2;
                _context8.next = 5;
                return new printers_api(_this8.$auth.getAccessToken()).retrieveServer(id);

              case 5:
                response = _context8.sent;

                _this8.server = response.data;
                _context8.next = 9;
                return _this8.refreshPrinters();

              case 9:
                _context8.next = 14;
                break;

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](2);

                _this8.notifyError(_context8.t0.message);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[2, 11]]);
      }))();
    },
    loadQuicketPrinters: function loadQuicketPrinters() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var opts, response;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                opts = {
                  headers: { "x-api-key": _this9.server.api_key },
                  params: { api_key: _this9.server.api_key }
                };
                _context9.next = 3;
                return axios_default.a.get(_this9.server.host + "/printers", opts);

              case 3:
                response = _context9.sent;
                return _context9.abrupt("return", response.data);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    loadPrinters: function loadPrinters() {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var response;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return new printers_api(_this10.$auth.getAccessToken()).retrievePrinters(_this10.server.id);

              case 2:
                response = _context10.sent;
                return _context10.abrupt("return", response.data);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    refreshPrinters: function refreshPrinters() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return _this11.loadPrinters();

              case 3:
                _this11.printers = _context11.sent;
                _context11.next = 9;
                break;

              case 6:
                _context11.prev = 6;
                _context11.t0 = _context11["catch"](0);

                _this11.notifyError(_context11.t0);

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[0, 6]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-141a6732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/PrintServerCreate.vue
var PrintServerCreate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-breadcrumb',{attrs:{"items":_vm.crumbs}}),_vm._v(" "),_c('b-container',[_c('b-card',{attrs:{"title":"Server"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('b-form-group',{attrs:{"id":"imputGroupHost","label":"Host:"}},[_c('b-form-input',{attrs:{"id":"host","description":"Host"},model:{value:(_vm.server.host),callback:function ($$v) {_vm.$set(_vm.server, "host", $$v)},expression:"server.host"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"inputGroupPrintersApiKey","label":"Api Key:"}},[_c('b-form-input',{attrs:{"id":"api_key","description":"Api Key"},model:{value:(_vm.server.api_key),callback:function ($$v) {_vm.$set(_vm.server, "api_key", $$v)},expression:"server.api_key"}})],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"server_type","hidden":"","description":"Type"},model:{value:(_vm.server.server_type),callback:function ($$v) {_vm.$set(_vm.server, "server_type", $$v)},expression:"server.server_type"}}),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Save")])],1)],1),_vm._v(" "),(!_vm.creating)?_c('b-card',{staticClass:"mt-5",attrs:{"title":"Printers"}},[_c('b-form',{staticClass:"d-flex mb-3",on:{"submit":function($event){$event.preventDefault();return _vm.addManualPrinter.apply(null, arguments)}}},[_c('label',{staticClass:"sr-only",attrs:{"for":"newPrinterDescription"}},[_vm._v("Printer name")]),_vm._v(" "),_c('b-form-input',{staticClass:"mr-2",attrs:{"id":"newPrinterDescription","placeholder":"Printer name, exactly as in Windows"},model:{value:(_vm.newPrinterDescription),callback:function ($$v) {_vm.newPrinterDescription=$$v},expression:"newPrinterDescription"}}),_vm._v(" "),_c('b-button',{staticClass:"text-nowrap",attrs:{"type":"submit","variant":"primary","disabled":_vm.addingPrinter || !_vm.newPrinterDescription.trim()}},[_vm._v("Add Printer")])],1),_vm._v(" "),_c('printers-list',{attrs:{"printers":_vm.printers}})],1):_vm._e()],1)],1)}
var PrintServerCreate_staticRenderFns = []
var PrintServerCreate_esExports = { render: PrintServerCreate_render, staticRenderFns: PrintServerCreate_staticRenderFns }
/* harmony default export */ var printers_PrintServerCreate = (PrintServerCreate_esExports);
// CONCATENATED MODULE: ./src/components/printers/PrintServerCreate.vue
var PrintServerCreate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrintServerCreate___vue_template_functional__ = false
/* styles */
var PrintServerCreate___vue_styles__ = null
/* scopeId */
var PrintServerCreate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintServerCreate___vue_module_identifier__ = null
var PrintServerCreate_Component = PrintServerCreate_normalizeComponent(
  PrintServerCreate,
  printers_PrintServerCreate,
  PrintServerCreate___vue_template_functional__,
  PrintServerCreate___vue_styles__,
  PrintServerCreate___vue_scopeId__,
  PrintServerCreate___vue_module_identifier__
)

/* harmony default export */ var components_printers_PrintServerCreate = (PrintServerCreate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/PrinterEdit.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var PrinterEdit = ({
  components: {
    "click-confirm": click_confirm_common_default.a
  },
  computed: {
    items: function items() {
      return [{
        text: "Home",
        href: "/"
      }, {
        text: "Server",
        to: {
          name: "EditPrintServer",
          params: { id: this.printer.print_server_id }
        }
      }, {
        text: "Printer",
        active: true
      }];
    }
  },
  mixins: [notify],
  watch: {
    $route: function $route(to) {
      this.loadItem(to.params.id);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.loadItem(to.params.id);
    });
  },
  data: function data() {
    return {
      printer: {
        id: 0,
        description: "",
        ticket_type: "label",
        print_server_id: 0
      },
      ticket_types: [{ value: "label", text: "Label" }, { value: "receipt", text: "Receipt" }],
      dimensions: [],
      dimension: {
        width: null,
        height: null
      },
      saving: false,
      fields: ["height", "width", "actions"]
    };
  },

  methods: {
    loadItem: function loadItem(id) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (is_integer_default()(parseInt(id, 0))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return new printers_api(_this.$auth.getAccessToken()).retrievePrinter(id);

              case 5:
                response = _context.sent;

                _this.printer = response.data;
                _this.loadDimensions(id);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

                _this.notifyError(_context.t0.message);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 10]]);
      }))();
    },
    loadDimensions: function loadDimensions(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return new printers_api(_this2.$auth.getAccessToken()).retrievePrinterDimensions(id);

              case 3:
                response = _context2.sent;

                _this2.dimensions = response.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                _this2.notifyError(_context2.t0.message);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    removeDimension: function removeDimension(id) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return new printers_api(_this3.$auth.getAccessToken()).deleteDimension(id);

              case 3:
                _context3.next = 5;
                return _this3.loadDimensions(_this3.printer.id);

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                _this3.notifyError(_context3.t0.message);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    createDimension: function createDimension() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return new printers_api(_this4.$auth.getAccessToken()).createDimension(_this4.printer.id, _this4.dimension);

              case 3:
                _this4.loadDimensions(_this4.printer.id);
                _this4.dimension = { width: null, height: null };
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

                _this4.notifyError(_context4.t0.message);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 7]]);
      }))();
    },
    updatePrinter: function updatePrinter() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return new printers_api(_this5.$auth.getAccessToken()).updatePrinter(_this5.printer.id, _this5.printer);

              case 3:
                _this5.loadItem(_this5.printer.id);
                _context5.next = 9;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);

                _this5.notifyError(_context5.t0.message);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 6]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e105a244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/PrinterEdit.vue
var PrinterEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.printer.description))]),_vm._v(" "),_c('b-form',{staticClass:"mt-5",attrs:{"inline":""}},[_c('label',{staticClass:"sr-only",attrs:{"for":"printerDescription"}},[_vm._v("Description")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"options":_vm.ticket_types},model:{value:(_vm.printer.ticket_type),callback:function ($$v) {_vm.$set(_vm.printer, "ticket_type", $$v)},expression:"printer.ticket_type"}}),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.saving,"variant":"primary"},on:{"click":_vm.updatePrinter}},[_vm._v("Save")])],1),_vm._v(" "),_c('p',[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.createDimension",modifiers:{"createDimension":true}}]},[_vm._v("Create Dimension")])],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"createDimension","title":"Create Dimension"},on:{"ok":_vm.createDimension}},[_c('b-input',{attrs:{"placeholder":"Width","type":"number"},model:{value:(_vm.dimension.width),callback:function ($$v) {_vm.$set(_vm.dimension, "width", $$v)},expression:"dimension.width"}}),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"Height","type":"number"},model:{value:(_vm.dimension.height),callback:function ($$v) {_vm.$set(_vm.dimension, "height", $$v)},expression:"dimension.height"}})],1),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.dimensions},scopedSlots:_vm._u([{key:"actions",fn:function(cell){return [_c('b-button-group',[_c('click-confirm',[_c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.removeDimension(cell.item.id)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"remove"}})],1)],1)],1)]}}])})],1)}
var PrinterEdit_staticRenderFns = []
var PrinterEdit_esExports = { render: PrinterEdit_render, staticRenderFns: PrinterEdit_staticRenderFns }
/* harmony default export */ var printers_PrinterEdit = (PrinterEdit_esExports);
// CONCATENATED MODULE: ./src/components/printers/PrinterEdit.vue
var PrinterEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrinterEdit___vue_template_functional__ = false
/* styles */
var PrinterEdit___vue_styles__ = null
/* scopeId */
var PrinterEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrinterEdit___vue_module_identifier__ = null
var PrinterEdit_Component = PrinterEdit_normalizeComponent(
  PrinterEdit,
  printers_PrinterEdit,
  PrinterEdit___vue_template_functional__,
  PrinterEdit___vue_styles__,
  PrinterEdit___vue_scopeId__,
  PrinterEdit___vue_module_identifier__
)

/* harmony default export */ var components_printers_PrinterEdit = (PrinterEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/CatalogueEdit.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CatalogueEdit = ({
  components: {
    "click-confirm": click_confirm_common_default.a
  },
  mixins: [notify],
  watch: {
    $route: function $route(to) {
      this.refresh(to.params.id);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.refresh(to.params.id);
    });
  },
  data: function data() {
    return {
      fields: ["description", "actions"],
      saving: false,
      isBusy: false,
      catalogue: {},
      printGroups: [],
      printGroup: {
        description: ""
      },
      id: null,
      items: [{
        text: "Home",
        href: "/"
      }, {
        text: "Catalogue",
        href: "#",
        active: true
      }]
    };
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.refresh(_this.id);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    dataProvider: function dataProvider() {
      if (!is_integer_default()(parseInt(this.id, 0))) {
        return [];
      }
      var promise = new printers_api(this.$auth.getAccessToken()).retrievePrintGroups(this.id);
      return promise.then(function (response) {
        var items = response.data;
        return items || [];
      });
    },
    refresh: function refresh(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (is_integer_default()(parseInt(id, 0))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _this2.id = id;
                _context2.next = 6;
                return new printers_api(_this2.$auth.getAccessToken()).retrieveCatalogue(id);

              case 6:
                response = _context2.sent;

                _this2.catalogue = response.data;

                _this2.$refs.table.refresh();
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);

                _this2.notifyError(_context2.t0.message);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 11]]);
      }))();
    },
    updateCatalogue: function updateCatalogue() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.saving = true;
                _context3.prev = 1;
                _context3.prev = 2;
                _context3.next = 5;
                return new printers_api(_this3.$auth.getAccessToken()).updateCatalogue(_this3.id, _this3.catalogue);

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](2);

                _this3.notifyError(_context3.t0.message);

              case 10:
                _context3.prev = 10;

                _this3.saving = false;
                return _context3.finish(10);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1,, 10, 13], [2, 7]]);
      }))();
    },
    moveUp: function moveUp(item) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(item.position === 0)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return new printers_api(_this4.$auth.getAccessToken()).updatePrintGroup(item.id, {
                  position: item.position - 1
                });

              case 5:
                _this4.$refs.table.refresh();
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);

                _this4.notifyError(_context4.t0.message);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 8]]);
      }))();
    },
    moveDown: function moveDown(item) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return new printers_api(_this5.$auth.getAccessToken()).updatePrintGroup(item.id, {
                  position: item.position + 1
                });

              case 3:
                _this5.$refs.table.refresh();
                _context5.next = 9;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);

                _this5.notifyError(_context5.t0.message);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 6]]);
      }))();
    },
    createPrintGroup: function createPrintGroup() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return new printers_api(_this6.$auth.getAccessToken()).createPrintGroup(_this6.id, _this6.printGroup);

              case 3:
                _this6.resetModal();
                _this6.refresh(_this6.id);
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);

                _this6.notifyError(_context6.t0.message);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 7]]);
      }))();
    },
    deletePrintGroup: function deletePrintGroup(item) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return new printers_api(_this7.$auth.getAccessToken()).deletePrintGroup(item.id);

              case 3:
                _this7.refresh(_this7.id);
                _context7.next = 9;
                break;

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);

                _this7.notifyError(_context7.t0.message);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 6]]);
      }))();
    },
    resetModal: function resetModal() {
      this.printGroup = { description: "" };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6721736","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/CatalogueEdit.vue
var CatalogueEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_vm._v(" "),_c('b-form',{staticClass:"mt-5",attrs:{"inline":""}},[_c('label',{staticClass:"sr-only",attrs:{"for":"catalogueDescrption"}},[_vm._v("Description")]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"catalogueDescription","placeholder":"Description"},model:{value:(_vm.catalogue.description),callback:function ($$v) {_vm.$set(_vm.catalogue, "description", $$v)},expression:"catalogue.description"}}),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.saving,"variant":"primary"},on:{"click":_vm.updateCatalogue}},[_vm._v("Save")])],1),_vm._v(" "),_c('b-table',{ref:"table",staticClass:"mt-5",attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.dataProvider,"small":""},scopedSlots:_vm._u([{key:"actions",fn:function(cell){return [_c('b-button-group',[_c('b-button',{staticClass:"align-top",attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){return _vm.moveUp(cell.item)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"arrow-up"}})],1),_vm._v(" "),_c('b-button',{staticClass:"align-top",attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){return _vm.moveDown(cell.item)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"arrow-down"}})],1),_vm._v(" "),_c('b-button',{staticClass:"align-top",attrs:{"size":"sm","variant":"outline-secondary","to":{ name: 'EditPrintGroup', params: { id: cell.item.id } }}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"edit"}})],1),_vm._v(" "),_c('click-confirm',[_c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.deletePrintGroup(cell.item)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"remove"}})],1)],1)],1)]}}])}),_vm._v(" "),_c('b-button-toolbar',{staticClass:"mt-5 float-right"},[_c('b-button-group',[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.createPrintGroup",modifiers:{"createPrintGroup":true}}],staticClass:"btn-circle btn-lg",attrs:{"variant":"primary"}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"plus"}})],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"createPrintGroup","title":"Create Printer Group"},on:{"ok":_vm.createPrintGroup}},[_c('b-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.printGroup.description),callback:function ($$v) {_vm.$set(_vm.printGroup, "description", $$v)},expression:"printGroup.description"}})],1)],1)}
var CatalogueEdit_staticRenderFns = []
var CatalogueEdit_esExports = { render: CatalogueEdit_render, staticRenderFns: CatalogueEdit_staticRenderFns }
/* harmony default export */ var printers_CatalogueEdit = (CatalogueEdit_esExports);
// CONCATENATED MODULE: ./src/components/printers/CatalogueEdit.vue
function CatalogueEdit_injectStyle (ssrContext) {
  __webpack_require__("3doe")
}
var CatalogueEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CatalogueEdit___vue_template_functional__ = false
/* styles */
var CatalogueEdit___vue_styles__ = CatalogueEdit_injectStyle
/* scopeId */
var CatalogueEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CatalogueEdit___vue_module_identifier__ = null
var CatalogueEdit_Component = CatalogueEdit_normalizeComponent(
  CatalogueEdit,
  printers_CatalogueEdit,
  CatalogueEdit___vue_template_functional__,
  CatalogueEdit___vue_styles__,
  CatalogueEdit___vue_scopeId__,
  CatalogueEdit___vue_module_identifier__
)

/* harmony default export */ var components_printers_CatalogueEdit = (CatalogueEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/PrintGroupPrintersList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PrintGroupPrintersList = ({
  components: {
    "click-confirm": click_confirm_common_default.a
  },
  mixins: [notify],
  props: ["printers"],
  data: function data() {
    return {
      fields: ["description", "ticket_type", "actions"]
    };
  },

  methods: {
    deletePrinter: function deletePrinter(printer) {
      this.$emit("deletePrinter", printer);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c4a0478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/PrintGroupPrintersList.vue
var PrintGroupPrintersList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Printer List")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.printers},scopedSlots:_vm._u([{key:"actions",fn:function(cell){return [_c('b-button-group',[_c('click-confirm',[_c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.deletePrinter(cell.item)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"remove"}})],1)],1)],1)]}}])})],1)}
var PrintGroupPrintersList_staticRenderFns = []
var PrintGroupPrintersList_esExports = { render: PrintGroupPrintersList_render, staticRenderFns: PrintGroupPrintersList_staticRenderFns }
/* harmony default export */ var printers_PrintGroupPrintersList = (PrintGroupPrintersList_esExports);
// CONCATENATED MODULE: ./src/components/printers/PrintGroupPrintersList.vue
var PrintGroupPrintersList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrintGroupPrintersList___vue_template_functional__ = false
/* styles */
var PrintGroupPrintersList___vue_styles__ = null
/* scopeId */
var PrintGroupPrintersList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintGroupPrintersList___vue_module_identifier__ = null
var PrintGroupPrintersList_Component = PrintGroupPrintersList_normalizeComponent(
  PrintGroupPrintersList,
  printers_PrintGroupPrintersList,
  PrintGroupPrintersList___vue_template_functional__,
  PrintGroupPrintersList___vue_styles__,
  PrintGroupPrintersList___vue_scopeId__,
  PrintGroupPrintersList___vue_module_identifier__
)

/* harmony default export */ var components_printers_PrintGroupPrintersList = (PrintGroupPrintersList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/printers/PrintGroupEdit.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var PrintGroupEdit = ({
  components: {
    "printer-list": components_printers_PrintGroupPrintersList
  },
  mixins: [notify],
  computed: {
    items: function items() {
      return [{
        text: "Home",
        href: "/"
      }, {
        text: "Catalogue",
        href: "/printers/catalogues/" + this.printGroup.catalogue_id + "/edit"
      }, {
        text: "Print Group",
        active: true
      }];
    }
  },
  data: function data() {
    return {
      printGroup: {},
      printGroupPrinters: [],
      servers: [],
      printers: [],
      printGroupId: null,
      selectedServerId: null,
      selectedPrinterId: null,
      saving: false
    };
  },

  watch: {
    $route: function $route(to) {
      this.printGroupId = to.params.id;
    }
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var response, servers;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.printGroupId = _this.$route.params.id;

              _context.next = 4;
              return new printers_api(_this.$auth.getAccessToken()).retrievePrintGroup(_this.$route.params.id);

            case 4:
              response = _context.sent;

              _this.printGroup = response.data;

              _context.next = 8;
              return new printers_api(_this.$auth.getAccessToken()).retrieveServers();

            case 8:
              response = _context.sent;
              servers = response.data;

              _this.servers = servers.map(function (x) {
                return { value: x.id, text: x.host };
              });
              _context.next = 13;
              return _this.loadPrintGroupPrinters();

            case 13:
              _this.printGroupPrinters = _context.sent;
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);

              _this.notifyError(_context.t0.message);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 16]]);
    }))();
  },

  methods: {
    loadPrintGroupPrinters: function loadPrintGroupPrinters() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new printers_api(_this2.$auth.getAccessToken()).retrievePrintGroupPrinters(_this2.printGroupId);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadPrinters: function loadPrinters(selectedId) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.printers = [];

                if (is_integer_default()(parseInt(selectedId, 0))) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;
                _context3.next = 6;
                return new printers_api(_this3.$auth.getAccessToken()).retrievePrinters(selectedId);

              case 6:
                response = _context3.sent;

                _this3.printers = response.data.map(function (x) {
                  return {
                    value: x.id,
                    text: x.description
                  };
                });
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](3);

                _this3.notifyError(_context3.t0.message);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 10]]);
      }))();
    },
    loadServers: function loadServers() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var response;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new printers_api(_this4.$auth.getAccessToken()).retrieveServer();

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    addPrinter: function addPrinter() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return new printers_api(_this5.$auth.getAccessToken()).addPrinterToGroup(_this5.selectedPrinterId, _this5.printGroupId);

              case 3:
                _this5.notifySuccess("Added printer");
                _context5.next = 6;
                return _this5.loadPrintGroupPrinters();

              case 6:
                _this5.printGroupPrinters = _context5.sent;
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);

                _this5.notifyError(_context5.t0.message);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    },
    deletePrinter: function deletePrinter(printer) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return new printers_api(_this6.$auth.getAccessToken()).removePrinterFromGroup(printer.id, _this6.printGroupId);

              case 3:
                _this6.notifySuccess("Removed Printer");
                _context6.next = 6;
                return _this6.loadPrintGroupPrinters();

              case 6:
                _this6.printGroupPrinters = _context6.sent;
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](0);

                _this6.notifyError(_context6.t0.message);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 9]]);
      }))();
    },
    updateDescription: function updateDescription() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var update;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.saving = true;
                _context7.prev = 1;
                _context7.prev = 2;
                update = { description: _this7.printGroup.description };
                _context7.next = 6;
                return new printers_api(_this7.$auth.getAccessToken()).updatePrintGroup(_this7.printGroup.id, update);

              case 6:
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](2);

                _this7.notifyError(_context7.t0.message);

              case 11:
                _context7.prev = 11;

                _this7.saving = false;
                return _context7.finish(11);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[1,, 11, 14], [2, 8]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2deb436a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/PrintGroupEdit.vue
var PrintGroupEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_vm._v(" "),_c('b-form',{staticClass:"mt-5 mb-5",attrs:{"inline":""}},[_c('label',{staticClass:"sr-only",attrs:{"for":"groupDescription"}},[_vm._v("Description")]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"groupDescription","placeholder":"Description"},model:{value:(_vm.printGroup.description),callback:function ($$v) {_vm.$set(_vm.printGroup, "description", $$v)},expression:"printGroup.description"}}),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.saving,"variant":"primary"},on:{"click":_vm.updateDescription}},[_vm._v("Save")])],1),_vm._v(" "),_c('b-container',[_c('b-form',[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.servers},on:{"change":_vm.loadPrinters},model:{value:(_vm.selectedServerId),callback:function ($$v) {_vm.selectedServerId=$$v},expression:"selectedServerId"}}),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.printers},model:{value:(_vm.selectedPrinterId),callback:function ($$v) {_vm.selectedPrinterId=$$v},expression:"selectedPrinterId"}}),_vm._v(" "),_c('b-button',{on:{"click":_vm.addPrinter}},[_vm._v("Add")])],1)],1),_vm._v(" "),_c('printer-list',{attrs:{"printers":_vm.printGroupPrinters},on:{"deletePrinter":_vm.deletePrinter}})],1)}
var PrintGroupEdit_staticRenderFns = []
var PrintGroupEdit_esExports = { render: PrintGroupEdit_render, staticRenderFns: PrintGroupEdit_staticRenderFns }
/* harmony default export */ var printers_PrintGroupEdit = (PrintGroupEdit_esExports);
// CONCATENATED MODULE: ./src/components/printers/PrintGroupEdit.vue
var PrintGroupEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrintGroupEdit___vue_template_functional__ = false
/* styles */
var PrintGroupEdit___vue_styles__ = null
/* scopeId */
var PrintGroupEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintGroupEdit___vue_module_identifier__ = null
var PrintGroupEdit_Component = PrintGroupEdit_normalizeComponent(
  PrintGroupEdit,
  printers_PrintGroupEdit,
  PrintGroupEdit___vue_template_functional__,
  PrintGroupEdit___vue_styles__,
  PrintGroupEdit___vue_scopeId__,
  PrintGroupEdit___vue_module_identifier__
)

/* harmony default export */ var components_printers_PrintGroupEdit = (PrintGroupEdit_Component.exports);

// EXTERNAL MODULE: ./node_modules/@okta/okta-auth-js/dist/okta-auth-js.umd.js
var okta_auth_js_umd = __webpack_require__("fqKN");
var okta_auth_js_umd_default = /*#__PURE__*/__webpack_require__.n(okta_auth_js_umd);

// EXTERNAL MODULE: ./node_modules/@okta/okta-vue/bundles/okta-vue.esm.js
var okta_vue_esm = __webpack_require__("3t5S");

// CONCATENATED MODULE: ./src/router/index.js












vue_esm["default"].use(vue_router_esm["a" /* default */]);

var oktaAuth = new okta_auth_js_umd["OktaAuth"]({
  issuer: vue_config_default.a.auth.issuer,
  clientId: vue_config_default.a.auth.clientId,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email"]
});
vue_esm["default"].use(okta_vue_esm["b" /* default */], { oktaAuth: oktaAuth });

var router = new vue_router_esm["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "home",
    component: src_components_Main,
    meta: {
      requiresAuth: true
    }
  }, { path: "/login/callback", component: okta_vue_esm["a" /* LoginCallback */] },

  // Printers API
  {
    path: "/printers/print_server",
    name: "CreatePrintServer",
    component: components_printers_PrintServerCreate,
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/printers/print_server/:id/edit",
    name: "EditPrintServer",
    component: components_printers_PrintServerCreate,
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/printers/printers/:id/edit",
    name: "EditPrinter",
    component: components_printers_PrinterEdit,
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/printers/catalogues/:id/edit",
    name: "EditCatalogue",
    component: components_printers_CatalogueEdit,
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/printers/print_groups/:id/edit",
    name: "EditPrintGroup",
    component: components_printers_PrintGroupEdit,
    meta: {
      requiresAuth: true
    }
  }]
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store.js




vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    auth: undefined
  },
  mutations: {
    auth: function auth(state, _auth) {
      window.localStorage.auth = stringify_default()(_auth);
      state.auth = _auth;
    },
    logout: function logout(state) {
      window.localStorage.removeItem("auth");
      state.auth = undefined;
    }
  }
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















// globally (in your main .js file)
vue_esm["default"].component("icon", Icon["a" /* default */]);
vue_esm["default"].use(dist_default.a);
vue_esm["default"].use(es["a" /* default */]);

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: "#app",
  store: store,
  router: src_router,
  template: "<App/>",
  components: { App: src_App }
});

/***/ }),

/***/ "PUbj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y9O/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dW2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jSVj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n9mN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/progress/_progress.js
var _progress = __webpack_require__("E9Zr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/progress/progress.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var progress = (_progress["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress.vue
function injectStyle (ssrContext) {
  __webpack_require__("dW2o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  progress,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var progress_progress = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vK/+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  printers: {
    host: "https://printers.quicktravel.com.au"
  },
  auth: {
    issuer: "https://kelsian.okta.com/oauth2/aus2r6kxqkqLBkb5w697",
    clientId: "0oa2r7fhjjXut27Di697"
  }
};

/***/ }),

/***/ "xBwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xhSA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3d5b58d2033c788d943c.js